import { render, staticRenderFns } from "./CreateTag.vue?vue&type=template&id=425ae3e2&scoped=true&"
import script from "./CreateTag.vue?vue&type=script&lang=js&"
export * from "./CreateTag.vue?vue&type=script&lang=js&"
import style0 from "./CreateTag.vue?vue&type=style&index=0&id=425ae3e2&scoped=true&lang=css&"
import style1 from "./CreateTag.vue?vue&type=style&index=1&id=425ae3e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425ae3e2",
  null
  
)

export default component.exports